import { useTodoCompletion } from "../hooks/todos/useTodoCompletion";
import { RealizedTodoModel } from "../reduxToolkit/todosSlice";
import { present } from "../../lib/util/present";

import './todoList.scss'

interface ToDoListProps {
  todos: RealizedTodoModel[]
}

export function ToDoList({todos}: ToDoListProps) {

  const [onClick, _, modal] = useTodoCompletion()

  const incompleteTodos = todos.filter((todo) => !present(todo.completed_at))
  const completedTodos = todos.filter((todo) => present(todo.completed_at))

  return <>
    <div className="todo-list">
      {incompleteTodos.map((todo) => <ToDoListItem
        key={todo.id}
        item={todo}
        onClick={() => onClick(todo)}
        />)}

      {completedTodos.map((todo) => <ToDoListItem
        key={todo.id}
        item={todo}
        complete
        />)}
    </div>

    {modal}
  </>
}

interface ToDoListItemProps {
  /**
   * Only the title is rendered, so callers can also list things that don't have
   * a realized todo row yet -- e.g. a submit blocker whose backend todo hasn't
   * synced down. Those are rendered without an onClick, so they read as
   * informational rather than actionable.
   */
  item: Pick<RealizedTodoModel, 'title'>

  complete?: boolean

  onClick?: () => any
}

export function ToDoListItem({item, complete, onClick}: ToDoListItemProps) {

  return <div className={`todo-list-item ${complete ? 'complete' : 'incomplete'}`}
      onClick={onClick}>
    <div className="todo-list-item__header">
      <i className="material-icons">{
        complete ? 'check_box' : 'check_box_outline_blank'
      }</i>
      <span>{item.title}</span>
    </div>
  </div>
}
